<div class="modal-header">
  <h4 class="modal-title">{{ 'user.secondary-user.add' | translate }}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  @if (error) {
    <app-error [error]="error"></app-error>
  }

  <div class="form-group">
    <label for="userSelect">{{ 'user.secondary-user.select' | translate }}</label>
    <p-select
      inputId="userSelect"
      [options]="availableUsers"
      [formControl]="selectedUserControl"
      optionLabel="displayName"
      optionValue="id"
      [placeholder]="'user.secondary-user.select' | translate"
      [showClear]="true"
      class="w-100"
    ></p-select>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="close()">
    {{ 'cancel' | translate }}
  </button>
  <button
    type="button"
    class="btn btn-primary"
    [disabled]="!selectedUserControl.value || isLoading"
    (click)="addSecondaryUser()"
  >
    @if (isLoading) {
      <span class="spinner-border spinner-border-sm me-2" role="status"></span>
    }
    {{ 'user.secondary-user.add' | translate }}
  </button>
</div>